import script from "./FooterPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterPortal.vue?vue&type=script&setup=true&lang=js"

import "./FooterPortal.vue?vue&type=style&index=0&id=46c6dd9d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46c6dd9d"]])

export default __exports__